import { toEventPayload, normalizeIncludeInReports } from 'application/util/event-report.util';

export default class BalanceUpdateService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    create(calendarId, event) {
        return this.apiService.post(`/calendars/${calendarId}/transactions/balance-updates`, toEventPayload(event, false)).then((result) => normalizeIncludeInReports(result.data));
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/transaction/balance-update.service.js